<template>
  <div :class="['activity-card__idle', type, { 'activity-card__idle--compact': compact, 'is-loading': isLoading }]">
    <div class="unstarted-icon-box" :class="`bg-${iconBg}`">
      <b-spinner v-if="isLoading" small class="text-white" />
      <feather-icon v-else :icon="featherIcon" size="30" />
    </div>
    <div class="labels">
      <div class="card-activity-title font-raleway font-weight-bold">{{ title }}</div>
      <div v-if="datetime" class="card-activity-timestamp">{{ datetime }}</div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

export default {
  name: "ActivityCardIdle",
  components: {
    BSpinner,
    FeatherIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    datetime: {
      type: String,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    featherIcon() {
      switch (this.type) {
        case "setup":
          return "SlidersIcon";
        case "start":
          return "PlayCircleIcon";
        case "stop":
          return "PauseCircleIcon";
        case "finish":
          return "CheckCircleIcon";
        default:
          return "PlayCircleIcon";
      }
    },
    iconBg() {
      switch (this.type) {
        case "setup":
          return "slate";
        case "start":
          return "orange";
        case "stop":
          return "red";
        case "finish":
          return "green";
        default:
          return "orange";
      }
    },
  },
};
</script>

<style lang="scss">
.activity-card__idle {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 14px 12px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 10px;

  &.is-loading {
    cursor: wait;
  }

  .unstarted-icon-box {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    margin-bottom: 8px;
    box-shadow: none;
    transition: transform 0.2s ease;

    &.bg-slate {
      background-color: #607d8b;
    }
    &.bg-orange {
      background-color: #ff9f43;
    }
    &.bg-red {
      background-color: #ea5455;
    }
    &.bg-green {
      background-color: #28c76f;
    }

    svg,
    .feather {
      width: 26px;
      height: 26px;
      stroke: #ffffff;
    }
  }

  .labels {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    text-align: center;

    .card-activity-title {
      font-size: 15px;
      line-height: 20px;
      color: #4c4541;
      font-family: "Raleway", sans-serif;
      font-weight: 700;
      text-align: center;
      margin: 0;
    }

    .card-activity-timestamp {
      font-size: 12px;
      line-height: 16px;
      color: #7e7570;
      font-family: "Raleway", sans-serif;
      text-align: center;
      margin-top: 2px;
    }
  }
}

@media (max-width: 480px) {
  .activity-card__idle {
    padding: 16px 10px;

    .unstarted-icon-box {
      width: 48px;
      height: 48px;
      margin-bottom: 8px;

      svg,
      .feather {
        width: 24px;
        height: 24px;
      }
    }

    .labels {
      .card-activity-title {
        font-size: 14px;
        line-height: 18px;
      }

      .card-activity-timestamp {
        font-size: 11px;
      }
    }
  }
}
</style>
